/**
 * scrollTargetElement
 * @description 指定されたid要素を持つHTMLタグまで、スムーズに画面をスクロールさせる
 * @param elementId
 * @return void
 */

export const scrollTargetElement = (elementId: string): void => {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

/**
 * scrollToPageTop
 * @description ページの一番上へ戻す。**アニメーションさせず即座に移動する。**
 *
 * `scrollTargetElement` との使い分け:
 * - **ページ全体を先頭に戻したいとき**（入力→確認のような画面の切り替え）はこちら
 * - **ページ内の特定の位置へ送りたいとき**（エラー箇所・編集中のブロック）は `scrollTargetElement`
 *
 * `scrollTargetElement` を「先頭へ戻す」用途に使うと2つ問題がある。
 * 1. **飛び先の要素がページ先頭とは限らない。** ヘッダーやパンくずの下にある要素を指すと
 *    そこへ着地するのでページ先頭には戻らない（#1390 の `#customerEnqueteTop` が実例で、
 *    実測で SP は 160px・PC は 139px の位置に着地し、パンくずの上端が sticky ヘッダーに潜る）
 * 2. **`assets/css/renewal/style.css:6` の `html { scroll-behavior: smooth }` が効く。**
 *    長いフォームだと数千px を数秒かけて動くことになり、その間に画面へ指が触れると
 *    ブラウザはプログラム側のスクロールを打ち切る
 *
 * @return void
 */
export const scrollToPageTop = (): void => {
  window.scrollTo({ top: 0, behavior: 'instant' });
};
